
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Navbar from './Components/NavBar'
import { Outlet } from 'react-router-dom';
import Footer from './Components/Footer';






function App() {
  return (
    <div className="App">

   
    <Navbar/>
    <Outlet/>
    <Footer/>
   
   

    
    </div>
  );
}

export default App;
